import { formatDate } from 'helpers/datetime.helper';
import PropTypes from 'prop-types';
import * as S from './styles';

export default function DateLine({
  label,
  date,
  labelColor,
  dateColor,
  placeholder,
}) {
  return (
    <S.DateLineBox>
      <S.DateIcon />
      <S.TextLine color={labelColor}>
        {label}
        :
      </S.TextLine>
      <S.TextLine color={dateColor}>
        {date ? formatDate(date) : placeholder}
      </S.TextLine>
    </S.DateLineBox>
  );
}

const availableColors = PropTypes.oneOf([
  'green',
  'metallic',
  'default',
  'blue',
]);

DateLine.propTypes = {
  label: PropTypes.string.isRequired,
  date: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  labelColor: availableColors,
  dateColor: availableColors,
  placeholder: PropTypes.string,
};

DateLine.defaultProps = {
  date: null,
  labelColor: 'metallic',
  dateColor: 'default',
  placeholder: 'Pending...',
};
